import { normalizeHyphens, toAscii } from 'japanese-string-utils';

export const sanitizeJapaneseNumber = (s: string) => {
  return [s]
    .map((v) => v.replace('　', ' ').trim())
    .map(toAscii)
    .map((v) => normalizeHyphens(v, '-'))[0];
};

export const sanitizeZipCode = (s: string) => {
  return [s].map((s) => s.replace(/[〒\-]/g, '')).map(sanitizeJapaneseNumber)[0];
};

export const isValidJapaneseZipcode = (s: string) => {
  return s.length === 7;
};
